var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconLayers = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 22,
  viewBox: "-583 1486 32 29"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "m-551 1494.286-16-8.286-16 8.286 16 8.285 16-8.285Zm-16-5.536 10.689 5.536-10.689 5.535-10.689-5.535 10.689-5.536Zm12.795 10.09 3.205 1.66-16 8.286-16-8.286 3.205-1.66 12.795 6.626Zm0 6.215 3.205 1.659-16 8.286-16-8.286 3.205-1.659 12.795 6.626Z"
})));
export default SvgIconLayers;